import React, { useRef } from 'react'

export default function SocialFeedSection() {
  const carouselRef = useRef(null)

  const scroll = (direction) => {
    if (!carouselRef.current) return
    const amount = direction === 'left' ? -380 : 380
    carouselRef.current.scrollBy({ left: amount, behavior: 'smooth' })
  }

  const posts = [
    {
      id: 1,
      image: '/_assets/facebook-opslag.png',
      alt: 'Fernisering og kunstværker i Ordblindeugen',
      platform: 'facebook',
      icon: 'fa-brands fa-facebook-f',
      tag: 'Emmerske Efterskole',
      caption: `Ordblindeugen sluttede af med en fernisering af de flotte kunstværker, de har lavet ugen igennem med temaet “hvordan ser din ordblindhed ud”.\nEr det ikke nogen flotte kunstværker? Vi er ret imponeret\n#emmerskeefterskole #ordblindhed #fernisering #fællesskab #Trivsel`,
      url: 'https://www.facebook.com/Eeskole/?locale=da_DK',
      actionText: 'Se på Facebook',
    },
    {
      id: 2,
      image: '/_assets/esbjerg-museum.jpg',
      alt: 'Tur til Esbjerg museum i Ordblindeugen',
      platform: 'facebook',
      icon: 'fa-brands fa-facebook-f',
      tag: 'Emmerske Efterskole',
      caption: `Ordblindeugen\nMens de fleste hyggede i svømmehallen tog andre en tur på Esbjerg museum og hyggede sig\n#emmerskeefterskole #hygge #fællesskab #sammenhold #ordblind`,
      url: 'https://www.facebook.com/Eeskole/?locale=da_DK',
      actionText: 'Se på Facebook',
    },
    {
      id: 3,
      image: '/_assets/billede.jpg',
      alt: 'Ordblindeuge med fokus på ordblindhed i hele Danmark',
      platform: 'facebook',
      icon: 'fa-brands fa-facebook-f',
      tag: 'Emmerske Efterskole',
      caption: `Ordblindeuge\nUge 40 er der fokus på ordblindhed ikke bare på Emmerske efterskole, men i hele Danmark.\nHør her, hvorfor sagen er vigtig\n#emmerskeefterskole #ordblindeuge #GoRed #ordblind #Trivsel`,
      url: 'https://www.facebook.com/Eeskole/?locale=da_DK',
      actionText: 'Se på Facebook',
    },
    {
      id: 4,
      image: '/_assets/ordblid-uge40.png',
      alt: 'Ordblindeuge - 9. klasse maler hvad de tænker på om ordblindhed',
      platform: 'instagram',
      icon: 'fa-brands fa-instagram',
      tag: '@emmerske_efterskole',
      caption: `Uge 40 er Ordblindeuge.\n9. klasse har fået opgaven at male, hvad de tænker på ift. ordblindhed.\nPå fredag er der fernisering - vi glæder os til at se de færdige og flotte resultater 👩‍🎨👨‍🎨🎨🖼️\n#emmerskeefterskole #ordblindeuge #sammenhold #fællesskab #kunst`,
      url: 'https://www.instagram.com/emmerske_efterskole/?hl=da',
      actionText: 'Se på Instagram',
    },
  ]

  return (
    <section className="bg-white py-16 sm:py-20 border-t border-stone-200" aria-label="Følg os på sociale medier">
      <div className="max-w-7xl mx-auto px-4 sm:px-6">
        {/* Header with arrows */}
        <div className="flex flex-col md:flex-row md:items-end justify-between gap-6 mb-8 sm:mb-10">
          <div>
            <p className="text-sm sm:text-base md:text-lg font-bold tracking-normal text-stone-500 mb-1">
              Hold dig opdateret
            </p>
            <h2 className="text-2xl sm:text-3xl lg:text-4xl font-extrabold text-[#1c2727] tracking-tight">
              Følg med på sociale medier
            </h2>
          </div>

          {/* Social direct links and navigation arrows */}
          <div className="flex items-center gap-4 flex-wrap sm:flex-nowrap">
            <div className="flex items-center gap-4 sm:gap-6">
              <a
                href="https://www.facebook.com/Eeskole/?locale=da_DK"
                target="_blank"
                rel="noopener noreferrer"
                className="inline-flex items-center gap-1.5 text-xs sm:text-sm font-bold text-black hover:opacity-75 transition-opacity"
              >
                <i className="fa-brands fa-facebook-f text-sm text-black" aria-hidden="true" />
                <span>Facebook</span>
              </a>
              <a
                href="https://www.instagram.com/emmerske_efterskole/?hl=da"
                target="_blank"
                rel="noopener noreferrer"
                className="inline-flex items-center gap-1.5 text-xs sm:text-sm font-bold text-black hover:opacity-75 transition-opacity"
              >
                <i className="fa-brands fa-instagram text-sm text-black" aria-hidden="true" />
                <span>Instagram</span>
              </a>
              <a
                href="https://www.youtube.com/@emmerskeefterskole"
                target="_blank"
                rel="noopener noreferrer"
                className="inline-flex items-center gap-1.5 text-xs sm:text-sm font-bold text-black hover:opacity-75 transition-opacity"
              >
                <i className="fa-brands fa-youtube text-sm text-black" aria-hidden="true" />
                <span>YouTube</span>
              </a>
            </div>

            {/* Arrows */}
            <div className="flex items-center gap-2">
              <button
                type="button"
                onClick={() => scroll('left')}
                className="text-stone-600 hover:text-black p-2 transition-colors focus:outline-none"
                aria-label="Forrige opslag"
              >
                <i className="fa-solid fa-arrow-left text-xl" aria-hidden="true" />
              </button>
              <button
                type="button"
                onClick={() => scroll('right')}
                className="text-stone-600 hover:text-black p-2 transition-colors focus:outline-none"
                aria-label="Næste opslag"
              >
                <i className="fa-solid fa-arrow-right text-xl" aria-hidden="true" />
              </button>
            </div>
          </div>
        </div>

        {/* Posts carousel */}
        <div
          ref={carouselRef}
          className="flex gap-6 overflow-x-auto pb-4 pt-1 scroll-smooth snap-x snap-mandatory scrollbar-none"
          style={{ scrollbarWidth: 'none' }}
        >
          {posts.map((post) => (
            <a
              key={post.id}
              href={post.url}
              target="_blank"
              rel="noopener noreferrer"
              className="group flex-shrink-0 w-[84vw] sm:w-[320px] md:w-[360px] snap-start flex flex-col bg-white rounded-2xl overflow-hidden border border-stone-200/80 hover:border-stone-300 hover:shadow-md transition-all duration-300"
            >
              {/* Image without overlay badge */}
              <div className="relative aspect-square overflow-hidden bg-stone-100">
                <img
                  src={post.image}
                  alt={post.alt}
                  loading="lazy"
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                />
              </div>

              {/* Content / caption */}
              <div className="p-5 flex-1 flex flex-col justify-between space-y-3">
                <div className="flex items-center justify-between gap-2">
                  <p className="text-xs font-semibold text-stone-500 tracking-wide truncate">
                    {post.tag}
                  </p>
                  <i className={`${post.icon} text-sm text-stone-400 group-hover:text-black transition-colors shrink-0`} aria-hidden="true" />
                </div>
                <p className="text-sm text-stone-700 line-clamp-4 leading-relaxed whitespace-pre-line">
                  {post.caption}
                </p>
                <div className="pt-2 flex items-center gap-1.5 text-xs font-semibold text-stone-800 group-hover:text-black">
                  <span>{post.actionText || 'Se opslag'}</span>
                  <i className="fa-solid fa-arrow-up-right-from-square text-[10px] group-hover:text-black" aria-hidden="true" />
                </div>
              </div>
            </a>
          ))}
        </div>
      </div>
    </section>
  )
}
